<sc-modal [size]="size" #modal>
    <ng-content></ng-content>
</sc-modal>